/* eslint-disable @typescript-eslint/no-explicit-any */
import camelCase from "lodash/camelCase";
import transform  from "lodash/transform";
import isObject from "lodash/isObject";

const camelcaseKeys = (obj: any) =>
	transform(obj, (result: any, value: unknown, key: string, target) => {
		const camelKey = Array.isArray(target) ? key : camelCase(key);
		result[camelKey] = isObject(value) ? camelcaseKeys(value as any) : value;
	});

export default camelcaseKeys;
